/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
module.exports = function() {
	return [ [ "antingen", "eller" ], [ "icke blott", "utan afven" ], [ "ju", "desto" ] ];
};
